// extracted by mini-css-extract-plugin
module.exports = {"root":"PartnerList_root__2mUp6","wrap":"PartnerList_wrap__A7gF8","list":"PartnerList_list__bquI_"};